// Generated by ReScript, PLEASE EDIT WITH CARE

import * as LocaleConstants$PorterinUtils from "../constants/LocaleConstants.mjs";

var india = "INDIA";

var uae = "UAE";

var turkey = "TURKEY";

var malaysia = "MALAYSIA";

var bangladesh = "BANGLADESH";

function countryForLocale(locale) {
  if (locale === LocaleConstants$PorterinUtils.en_AE) {
    return uae;
  } else if (locale === LocaleConstants$PorterinUtils.en_TR || locale === LocaleConstants$PorterinUtils.tr_TR) {
    return turkey;
  } else if (locale === LocaleConstants$PorterinUtils.en_MY) {
    return malaysia;
  } else if (locale === LocaleConstants$PorterinUtils.en_BD || locale === LocaleConstants$PorterinUtils.bn_BD) {
    return bangladesh;
  } else {
    return india;
  }
}

var pageviewKafkaEndpoint = "/log_pageview_to_kafka";

var utm_source = "utm_source";

var utm_medium = "utm_medium";

var utm_campaign = "utm_campaign";

var utm_term = "utm_term";

var utm_content = "utm_content";

var timeFormat = "YYYY-MM-DD hh:mm:ss";

export {
  pageviewKafkaEndpoint ,
  utm_source ,
  utm_medium ,
  utm_campaign ,
  utm_term ,
  utm_content ,
  india ,
  uae ,
  turkey ,
  malaysia ,
  bangladesh ,
  countryForLocale ,
  timeFormat ,
}
/* No side effect */
